<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<h2 id="AddChildSubscriptionDialog" mat-dialog-title appLifecycleTracker
    trackerName="add-child-subscription-dialog">{{ fTitle }}</h2>

<mat-dialog-content>
    <form id="registerForm" [formGroup]="registerForm">
        <div class="">
          <span *ngIf="choosePlan">
              <mat-form-field appearance="outline">
                  <mat-label>{{ 'L_PRODUCT' | translate }}</mat-label>
                  <mat-select formControlName="edition" [value]="PlanChoiceValue.PLUS" (valueChange)="onEditionChanged($event)">
                      <mat-option *ngIf="this.bitLockerCount"
                                  value="BitLocker">{{ 'product_and_plan.plan.bitlocker-label' | translate }}</mat-option>
                      <mat-option *ngIf="this.plusCount" [value]="PlanChoiceValue.PLUS">{{ fBusiness }}</mat-option>
                      <mat-option *ngIf="this.hardwareCount"
                                  [value]="PlanChoiceValue.HARDWARE">{{ 'product_and_plan.plan.hardware-label' | translate }}</mat-option>
                      <mat-option *ngIf="this.hardware2Count"
                                  [value]="PlanChoiceValue.HARDWARE2">{{ 'product_and_plan.plan.hardware2-label' | translate }}</mat-option>
                      <mat-option *ngIf="this.fdeCount"
                                  [value]="PlanChoiceValue.FDE">{{ 'product_and_plan.plan.fde-label' | translate }}</mat-option>
                      <mat-option *ngIf="this.agentCount"
                                  [value]="PlanChoiceValue.AGENT">{{ 'product_and_plan.plan.agent-label' | translate }}</mat-option>
                  </mat-select>
              </mat-form-field>
          </span>
        </div>

        <div *ngIf="selectedEdition === PlanChoiceValue.HARDWARE || selectedEdition === PlanChoiceValue.HARDWARE2" class="max-drive">
            <span>{{ 'organizations.sub.max-drive-label' | translate }}</span><span>{{ maxDrivePerInstallation }}</span>
        </div>

        <div class="">
            <mat-form-field class="licenses-field" appearance="outline">
                <mat-label>{{ fLicenses }}</mat-label>
                <input id="registerFormLicenses" min="1" [max]="maxCount" matInput type="number"
                       formControlName="licenses" placeholder="{{fLicenses}}"/>
            </mat-form-field>
            {{ maxCount }} {{ fAvailable }}
        </div>
        <div>

            <div class="controls-row">
                @if (selectedEdition == PlanChoiceValue.HARDWARE || selectedEdition == PlanChoiceValue.HARDWARE2) {
                    <mat-form-field appearance="outline">
                        <mat-label>{{ 'ADO_EXPIRES' | translate }}</mat-label>
                        <input matInput value="{{ 'NON_EXPIRING' | translate }}" [disabled]="true">
                    </mat-form-field>
                } @else {
                    <mat-form-field appearance="outline">
                        <mat-label>{{ 'ADO_EXPIRES' | translate }}</mat-label>
                        <input matInput [matDatepicker]="myExpDatepicker" formControlName="expirationDate"
                               [min]="this.minDate" [max]="this.maxDate" (click)="myExpDatepicker.open()"
                               (dateChange)="onExpirationChanged()">
                        <mat-datepicker-toggle matSuffix [for]="myExpDatepicker"></mat-datepicker-toggle>
                        <mat-datepicker #myExpDatepicker></mat-datepicker>
                    </mat-form-field>
                }

                <mat-form-field appearance="outline" [ngStyle]="{'margin-left': '1em'}">
                    <mat-label>{{ 'MAINT_EXPIRES' | translate }}</mat-label>
                    <input matInput [matDatepicker]="myMaintDatepicker" formControlName="maintenance_end"
                           [min]="this.minDate" [max]="this.maxDate" (click)="myMaintDatepicker.open()">
                    <mat-datepicker-toggle matSuffix [for]="myMaintDatepicker"></mat-datepicker-toggle>
                    <mat-datepicker #myMaintDatepicker></mat-datepicker>
                </mat-form-field>
            </div>

            <div class="controls-row" *ngIf="selectedEdition !== PlanChoiceValue.HARDWARE &&
                    selectedEdition !== PlanChoiceValue.HARDWARE2 &&
                    selectedEdition !== PlanChoiceValue.FDE &&
                    selectedEdition !== PlanChoiceValue.AGENT">
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'ADO_DELAY' | translate }}</mat-label>
                    <input id="editDurationDelay" matInput type="number" min=0 max="6" #durationDelay
                           (change)="onDelayChange($event)"/>
                </mat-form-field>&nbsp;

                <span>{{ 'ADO_DURATION' | translate }}</span>
            </div>

        </div>

        <mat-form-field *ngIf="selectedEdition !== PlanChoiceValue.HARDWARE &&
                selectedEdition !== PlanChoiceValue.HARDWARE2 &&
                selectedEdition !== PlanChoiceValue.FDE &&
                selectedEdition !== PlanChoiceValue.AGENT" appearance="outline">
            <mat-label>{{ "organizations.sub.type_label" | translate }}</mat-label>
            <mat-select [(value)]="subType">
                <mat-option id="subType" *ngFor="let type of subTypes" [value]="type">
                    {{ "organizations.sub.type." + type.label | translate }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <div *ngIf="selectedEdition === PlanChoiceValue.HARDWARE || selectedEdition === PlanChoiceValue.PLUS ||
                selectedEdition === PlanChoiceValue.HARDWARE2 || selectedEdition === PlanChoiceValue.FDE ||
                 selectedEdition === PlanChoiceValue.AGENT" class="single-row">
            <mat-checkbox color="primary" formControlName="enablePBAExtendedFeatures">
            <span class="checkbox-with-icon">
              <span>Enable PBA extended features</span>
              <span tabindex="0"
                    aria-label="Includes TPM and non-interactive Security Key"
                    matTooltip="Includes TPM and non-interactive Security Key"
                    matTooltipPosition="right">
                  <span class="mdi mdi-information-outline circle-info-icon"></span>
              </span>
            </span>
            </mat-checkbox>
        </div>

        <div *ngIf="selectedEdition === PlanChoiceValue.HARDWARE || selectedEdition === PlanChoiceValue.PLUS ||
                selectedEdition === PlanChoiceValue.HARDWARE2 ||  selectedEdition === PlanChoiceValue.FDE ||
                selectedEdition === PlanChoiceValue.AGENT" class="single-row">
            <mat-checkbox color="primary" class="pba-features-checkbox" formControlName="enablePBALogErase">
                <span>Enable PBA Command Log erase during Disk Erasure</span>
            </mat-checkbox>
        </div>

        <mat-divider class="divider"></mat-divider>

        <div>
            <mat-checkbox color="primary" class="send-email-checkbox" formControlName="sendEmail"
                          (change)="onSendEmailCheckChanged($event)">
                {{ fNotify }}
            </mat-checkbox>
            <app-language-selector
                    label=""
                    [disabled]="!sendEmail"
                    [selectedLanguage]="selectedLanguage"
                    (valueChange)="onLanguageChanged($event)">
            </app-language-selector>
        </div>

    </form>
</mat-dialog-content>
<div mat-dialog-actions class="button-wrapper">
    <button id="AddChildSubscriptionDialogCancel" mat-raised-button
            (click)="onCancelClick()"
            type="button">
        {{ fCancel }}
    </button>
    <button id="AddChildSubscriptionDialogSave" mat-raised-button
            (click)="onSubmit()"
            [disabled]="!registerForm.valid || invalidExpiration || invalidDelay"
            type="button"
            color="primary">
        {{ fSave }}
    </button>
</div>
